import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { SrIcon } from "@/components/ui/SrIcon";
import { formatNOK } from "@/lib/format";
import { ProjectChip } from "./ProjectChip";
import type { InboxInvoice } from "@/hooks/use-pm-inbox";

interface Props {
  invoice: InboxInvoice;
}

export function RowFakturering({ invoice: inv }: Props) {
  const isStartup = inv.invoiceType === "startup";
  const label = isStartup ? "Send oppstart" : "Send sluttfaktura";
  const description = isStartup
    ? "Oppstartsfaktura ikke sendt"
    : "Sluttfaktura klar — prosjekt ferdig";
  const subline = isStartup
    ? `${inv.pct}% av kontraktssum`
    : `${inv.pct}% av kontraktssum · Etter ferdigstilling`;

  return (
    <>
      {/* VIB-959 (fase 2): desktop-grid kun fra xl:, mobilkort under. Ansatt-
          flyt A-funn — PM-innboksen hadde ingen mobiltilpasning. */}
      <div className="hidden xl:grid grid-cols-[24px_1fr_auto_auto] items-center gap-3.5 px-5 py-3.5 border-t border-border/40">
        <div className="w-6 h-6 rounded bg-foreground/5 text-foreground/70 inline-flex items-center justify-center">
          <SrIcon name="receipt" className="w-3.5 h-3.5" />
        </div>
        <div className="min-w-0">
          <div className="mb-1">
            <ProjectChip
              projectId={inv.projectId}
              projectCode={inv.projectCode}
              projectName={inv.projectName}
              customerName={inv.customerName}
            />
          </div>
          <div className="text-sm font-medium">{description}</div>
          <div className="text-xs text-muted-foreground">{subline}</div>
        </div>
        <span className="text-sm font-semibold tabular-nums whitespace-nowrap">
          {formatNOK(inv.estimatedAmount)}
        </span>
        <Button asChild size="sm" className="h-8 text-xs">
          <Link to={`/prosjekter/${inv.projectId}/faktura?type=${inv.invoiceType}`}>
            {label}
          </Link>
        </Button>
      </div>

      <div className="xl:hidden px-4 py-3 border-t border-border/40 space-y-2.5">
        <div className="flex items-start gap-2.5">
          <div className="w-7 h-7 rounded bg-foreground/5 text-foreground/70 inline-flex items-center justify-center shrink-0">
            <SrIcon name="receipt" className="w-3.5 h-3.5" />
          </div>
          <div className="min-w-0 flex-1">
            <div className="mb-1">
              <ProjectChip
                projectId={inv.projectId}
                projectCode={inv.projectCode}
                projectName={inv.projectName}
                customerName={inv.customerName}
              />
            </div>
            <div className="text-sm font-medium">{description}</div>
            <div className="text-xs text-muted-foreground">{subline}</div>
          </div>
          <span className="text-sm font-semibold tabular-nums whitespace-nowrap shrink-0">
            {formatNOK(inv.estimatedAmount)}
          </span>
        </div>
        <Button asChild size="sm" className="w-full h-10 text-xs">
          <Link to={`/prosjekter/${inv.projectId}/faktura?type=${inv.invoiceType}`}>
            {label}
          </Link>
        </Button>
      </div>
    </>
  );
}
